import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect, useContext } from 'react';
import { FormGroup, Label, Input, Col, Row } from 'reactstrap';
import Avatar from '../../../Basic/Avatar';
import { uploadAvatar, deleteAvatar } from '../../api';
import { UserContext } from '../userContext';
import { withSection } from '../withSection';
var AvatarInfo = withSection(function (_ref) {
  var prefix = _ref.prefix,
      userPreferencesCallback = _ref.userPreferencesCallback,
      trans = _ref.trans;

  var _useContext = useContext(UserContext),
      userData = _useContext.userData,
      updateUserData = _useContext.updateUserData;

  var currentAvatar = userData.currentAvatar,
      _userData$profile = userData.profile,
      profile = _userData$profile === void 0 ? {
    firstName: '',
    lastName: ''
  } : _userData$profile;

  var _useState = useState(200),
      _useState2 = _slicedToArray(_useState, 2),
      avatarWidth = _useState2[0],
      setAvatarWidth = _useState2[1];

  var _useState3 = useState({
    initImg: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      avatarRef = _useState4[0],
      setAvatarRef = _useState4[1];

  useEffect(function () {
    if (avatarRef && avatarRef.initImg) {
      avatarRef.initImg(currentAvatar);
    }
  }, [currentAvatar, avatarRef]);
  useEffect(function () {
    var getAvatarWidth = function getAvatarWidth() {
      var _dom = document.querySelector('#MyProfile');

      if (!_dom) return;
      var avatarWidth = _dom.clientWidth * 0.33 - 15;
      setAvatarWidth(avatarWidth);
    };

    getAvatarWidth();
    window.addEventListener('resize', getAvatarWidth);
    return function () {
      window.removeEventListener('resize', getAvatarWidth);
    };
  }, []);

  var upLoadImg = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blobImg) {
      var formData, _yield$uploadAvatar, data, newUserData;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formData = new FormData();
              formData.append('file', blobImg);
              _context.prev = 2;
              _context.next = 5;
              return uploadAvatar(formData);

            case 5:
              _yield$uploadAvatar = _context.sent;
              data = _yield$uploadAvatar.data;
              newUserData = _objectSpread(_objectSpread({}, userData), {}, {
                currentAvatar: data.url
              });
              updateUserData(newUserData);
              userPreferencesCallback({
                currentUserData: newUserData,
                currentAvatar: data.url,
                uploadAvatarSuccess: 'success'
              });
              return _context.abrupt("return", true);

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);
              return _context.abrupt("return", false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 13]]);
    }));

    return function upLoadImg(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onInputChange = function onInputChange(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;

    var profile = _objectSpread(_objectSpread({}, userData.profile), {}, _defineProperty({}, name, value));

    updateUserData(_objectSpread(_objectSpread({}, userData), {}, {
      profile: profile
    }));
  };

  var deleteImg = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var newUserData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return deleteAvatar();

            case 3:
              newUserData = _objectSpread(_objectSpread({}, userData), {}, {
                currentAvatar: ''
              });
              updateUserData(newUserData);
              userPreferencesCallback({
                currentUserData: newUserData,
                currentAvatar: '',
                deleteAvatarSuccess: 'success'
              });
              return _context2.abrupt("return", true);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
              return _context2.abrupt("return", false);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    return function deleteImg() {
      return _ref3.apply(this, arguments);
    };
  }();

  var formRender = function formRender(size) {
    return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: size
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      for: "firstName"
    }, trans('SFxUserPreferencesFirstNameLabel')), !profile.firstName && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix, "-require")
    }, "*"), /*#__PURE__*/React.createElement(Input, {
      name: "firstName",
      defaultValue: profile.firstName,
      onChange: onInputChange,
      maxLength: 50
    }))), /*#__PURE__*/React.createElement(Col, {
      md: size
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      for: "lastName"
    }, trans('SFxUserPreferencesLastNameLabel')), !profile.lastName && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix, "-require")
    }, "*"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      name: "lastName",
      defaultValue: profile.lastName,
      onChange: onInputChange,
      maxLength: 50
    }))));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Avatar, {
    onRef: function onRef(avatarRef) {
      setAvatarRef(avatarRef);
    },
    width: avatarWidth,
    height: avatarWidth,
    upLoadImg: upLoadImg,
    currentImg: currentAvatar,
    deleteImg: deleteImg,
    readonly: !!(avatarWidth < 170)
  }, avatarWidth > 105 && formRender(6)), avatarWidth < 105 && formRender(4));
});
export default AvatarInfo;